import React from 'react';
import classNames from 'classnames';

import Icon from 'assets/icons';

import styles from './SkeletonList.module.scss';

const SkeletonGroup = () => {
  return (
    <div className={styles.group}>
      <div className={styles.heading}>
        <Icon.TriangleDown className={classNames(styles.moreListIcon)} />
        <div className={styles.headingText}></div>
      </div>

      <div className={styles.members}>
        <div className={styles.member}>
          <div className={styles.memberAvatar}></div>
          <div className={styles.memberName}></div>
        </div>

        <div className={styles.member}>
          <div className={styles.memberAvatar}></div>
          <div className={styles.memberName}></div>
        </div>

        <div className={styles.member}>
          <div className={styles.memberAvatar}></div>
          <div className={styles.memberName}></div>
        </div>
      </div>
    </div>
  );
};

interface SkeletonListProps {
  lists?: number;
}

export const SkeletonList: React.FC<SkeletonListProps> = ({ lists = 3 }) => {
  const renderSkeletonGroup = () => {
    const groups = [];

    for (let i = 0; i < lists; i++) {
      groups.push(<SkeletonGroup key={i} />);
    }

    return groups;
  };

  return <div>{renderSkeletonGroup()}</div>;
};

export default SkeletonList;
